/**
* Phone Carousel CTA JS
* -----------------------------------------------------------------------------
*
* All the JS for the Phone Carousel CTA component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'phone-carousel-cta',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.phone-carousel__splide' ).length ) {
        $( '.phone-carousel__splide' ).each( function( index, element ) {
          const slider = new Splide( $( element )[0], {
            type: 'fade',
            rewind: true,
            gap: '2rem',
            arrows: false,
            pagination: true,
            speed: 1000,
          } );
          slider.mount();
          const section = $( '.phone-carousel__splide' );
          let interval;

          function startInterval() {
            clearInterval( interval );
            interval = setInterval( () => {
              nextSlide();
            }, 4000 );
          }

          function nextSlide() {
            slider.go( '+${i}' );
          }
          startInterval();

          // Restart the interval on button click
          $( '.splide__pagination__page' ).on( 'click', function() {
            startInterval();
          } );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'phone-carousel-cta', COMPONENT );
} )( app );
